/* eslint-disable react-hooks/exhaustive-deps */
import { Suspense, useEffect } from "react";
import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import Helmet from "react-helmet";
import { useDispatch } from "react-redux";
import { saveAppConfig } from "../redux/actions/config";
import DefaultRoutes from "./routes";
import Middleware from "./middleware";

// Layouts
import Layout from "../layout/index";
import BlankLayout from "../layout/blank";
import PanelLayout from "../layout/panel";
import JustNavLayout from "../layout/justNav";
// Components
import GoToTop from "../components/goToTop";
import axios from "axios";
// import UserLocation from "Components/userLocation";

// All of the available layouts
const Layouts = { BlankLayout, JustNavLayout, PanelLayout };

const AppRouter = ({ config }) => {
  const dispatch = useDispatch();

  const query = new URLSearchParams(useLocation().search);
  const AllRoutes = [...(config.Routes || []), ...DefaultRoutes];

  const history = useHistory();

  const layoutRoutesAndPaths = (layout) => {
    const LayoutRoutes = [];
    const LayoutPaths = [];

    AllRoutes.filter((route) => {
      if (route.layout === layout) {
        LayoutRoutes.push(route);
        LayoutPaths.push(route.path);
      }
    });

    return { LayoutRoutes, LayoutPaths };
  };
  const handleRoutes = () => {
    return Object.keys(Layouts).map((layout, index) => {
      const LayoutTag = Layouts[layout];
      const { LayoutRoutes, LayoutPaths } = layoutRoutesAndPaths(layout);

      return (
        <Route path={LayoutPaths} key={index}>
          <LayoutTag allRoutes={AllRoutes}>
            <Switch>
              {LayoutRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  render={() => (
                    <Suspense fallback={null}>
                      <Helmet>
                        <title>{`${config.PanelTitle} ${
                          route.name ? `| ${route.name}` : ""
                        }`}</title>
                      </Helmet>
                      <div
                        style={{
                          userSelect: "none",
                        }}
                      >
                        {renderRoute(route)}
                      </div>
                    </Suspense>
                  )}
                />
              ))}
            </Switch>
          </LayoutTag>
        </Route>
      );
    });
  };
  const renderRoute = (route) => {
    const Component = route.component;
    const result = <Component />;

    if (route.authNeed === false) return result;
    return <Middleware>{result}</Middleware>;
  };

  useEffect(() => {
    if (window.localStorage.getItem("from")) {
      window.localStorage.removeItem("from");
      window.location.reload();
    }
    dispatch(saveAppConfig(config));
    // axios.post("https://api.behamrah.ir/api/v1/user/shahrzad_test/log", {
    //   log:
    //     window.location.href +
    //     ", params: " +
    //     Array.from(query.keys())
    //       .map((item) => item + ":" + query.get(item))
    //       .join(", "),
    // });
    if (window.localStorage.getItem("redirect_url")) {
      const page = window.localStorage.getItem("redirect_url");
      window.localStorage.removeItem("redirect_url");
      history.push(page);
    } else if (
      history.length > 3 &&
      localStorage.getItem("agent_service") === "shahrzad"
    ) {
      const page = window.location.pathname;
      window.localStorage.setItem("redirect_url", page);
      window.history.go(-history.length + 1);
    }
  }, []);

  return (
    <>
      {/* <p style={{ wordWrap: "break-word" }}>
        {window.localStorage.key(4) +
          ":" +
          window.localStorage.getItem("agent_service")}
      </p> */}
      <GoToTop />

      <Layout>
        <Helmet>
          <meta
            http-equiv="cache-control"
            content="no-cache, no-store, must-revalidate"
          />
          <meta http-equiv="expires" content="0" />
          <meta http-equiv="pragma" content="no-cache" />
        </Helmet>
        {/* {localStorage.getItem("agent_service") !== "shahrzad" && (
            <UserLocation />
          )} */}

        <Switch>{handleRoutes()}</Switch>
      </Layout>
    </>
  );
};

export default AppRouter;
